"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const react_1 = __importStar(require("react"));
const cross_1 = require("../../icons/cross");
const magnifyingGlass_1 = require("../../icons/magnifyingGlass");
const useCallOnKeyPress_1 = require("@geome/react-components-next/lib/hooks/callOnKeyPress/useCallOnKeyPress");
const useBEM_1 = require("@geome/react-next/lib/hooks/useBEM");
const SearchInput = ({ value, placeholder, onChange, id = "search-input", }) => {
    const { translate } = (0, i18n_1.useI18n)();
    const baseToken = "sections.locations_list.search";
    const inputRef = (0, react_1.useRef)(null);
    const clear = (0, react_1.useCallback)(() => onChange(""), [onChange]);
    const onClearKeyDown = (0, useCallOnKeyPress_1.useCallOnKeyPress)(clear, ["Enter", " "]);
    const onKeyDown = (0, useCallOnKeyPress_1.useCallOnKeyPress)(() => {
        if (inputRef.current)
            inputRef.current.blur();
    }, ["Enter"]);
    const wrapperClassName = (0, useBEM_1.useBEM)({
        block: "search-input",
        element: "wrapper",
        modifiers: {
            filled: value !== "",
        },
    });
    return (react_1.default.createElement("div", { className: wrapperClassName },
        react_1.default.createElement("div", { className: "search-input__icon search-input__icon--search" },
            react_1.default.createElement(magnifyingGlass_1.MagnifyingGlassIcon, null)),
        react_1.default.createElement("label", { className: "search-input--floating-label", htmlFor: id }, placeholder !== null && placeholder !== void 0 ? placeholder : translate(`${baseToken}.placeholder`)),
        react_1.default.createElement("input", { ref: inputRef, id: id, type: "text", role: "searchbox", "aria-label": translate(`${baseToken}.label`), className: "search-input", onChange: ({ target }) => onChange(target.value), value: value, onKeyDown: onKeyDown, autoComplete: "off", spellCheck: "false" }),
        value.length > 0 && (react_1.default.createElement("div", { className: "search-input__icon search-input__icon--clear", tabIndex: 0, onClick: clear, role: "button", title: translate(`${baseToken}.clear_label`), onKeyDown: onClearKeyDown },
            react_1.default.createElement(cross_1.CrossIcon, { size: 14 })))));
};
exports.SearchInput = SearchInput;
